import React, { useState } from "react";
import axios from 'axios';
import '../App.css';
import { useNavigate} from "react-router-dom";

const SignUp = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/signup/', {username, password});
            console.log(response.data);
            navigate('/login');

        } catch (error) {
            console.log(error);
        }
    };

    return(
        <div className="centered-form">
            <form onSubmit={handleSubmit}>
                <label>
                    Username:
                    <input type='text' value={username} onChange={e =>setUsername(e.target.value)} />
                </label>
                <label>
                    Password:
                    <input type='password' value={password} onChange={e =>setPassword(e.target.value)}/>
                </label>
                <button type="submit">Sign Up</button>
            </form>
        </div>
    );
};

export default SignUp;